// Alignment/snapping helper shared by the click-to-place flow (VideoPreviewCanvas.vue) and the
// interactive canvas drag (OverlayCanvas.vue) - echoes the Story Maker's blue center-line snap
// (storyTab/storyMaker/draggable.vue's axeX/axeY), extended with quarter marks and snapping to
// other overlays that are visible at the same moment of the video (not just canvas center).
const CANVAS_FRACTIONS = [0.25, 0.5, 0.75]
const TOLERANCE_PCT = 0.012 // ~1.2% of canvas width/height - scale-independent, unlike a fixed px tolerance

export const getSimultaneousOverlays = (overlays, currentMs, excludeId) => (overlays || []).filter(o => (
    o.id !== excludeId && currentMs >= o.startMs && currentMs <= o.endMs
))

const closestTarget = (value, targets) => {
    let best = null
    targets.forEach((pct) => {
        const distance = Math.abs(value - pct)
        if (distance <= TOLERANCE_PCT && (!best || distance < best.distance)) best = { pct, distance }
    })
    return best
}

// Given a candidate xPct/yPct (0-1, normalized to canvas size), returns the snapped x/y (or null
// if nothing is close enough) against canvas quarter/center marks and any other overlay active at
// `currentMs`.
export const computeSnap = (xPct, yPct, overlays, currentMs, excludeId) => {
    const targetsX = [...CANVAS_FRACTIONS]
    const targetsY = [...CANVAS_FRACTIONS]

    getSimultaneousOverlays(overlays, currentMs, excludeId).forEach((o) => {
        targetsX.push(o.transform.xPct)
        targetsY.push(o.transform.yPct)
    })

    const matchX = closestTarget(xPct, targetsX)
    const matchY = closestTarget(yPct, targetsY)

    return {
        x: matchX ? matchX.pct : null,
        y: matchY ? matchY.pct : null
    }
}
